import { OperationGroupCreate, TriggerCreate } from '@ekkogmbh/apisdk';
import { Stack, Typography } from '@mui/material';
import React from 'react';
import { OperationCard } from './OperationCard';
import { TriggerCard } from './TriggerCard';
import { convertCoordinateToPath } from 'src/Common/Helper/Nodes';
import { CenteredColumn, ReactiveRow } from 'src/Common/Components/Stacks';
interface Props {
  operationGroup: OperationGroupCreate;
  file?: File;
}

const overlineStyle = { fontWeight: 700 };

const NamedValue = ({ name, value }: { name: string; value: React.ReactNode }): React.JSX.Element => (
  <Stack direction={'column'}>
    <Typography variant="overline" color={'primary'} style={overlineStyle}>
      {name}
    </Typography>
    <Typography variant="h6" gutterBottom>
      {value}
    </Typography>
  </Stack>
);

export const OperationGroupCreateOverview = ({ operationGroup, file }: Props): React.JSX.Element => (
  <ReactiveRow>
    <CenteredColumn width={'100%'}>
      <NamedValue name={'Name'} value={operationGroup.name} />
      <NamedValue name={'Description'} value={operationGroup.description} />
      <NamedValue name={'Area'} value={convertCoordinateToPath(operationGroup.node)} />
      {file !== undefined && (
        <Stack direction={'column'}>
          <NamedValue name={'Filename'} value={file.name} />
          <NamedValue name={'Filesize'} value={Number((file as File).size / 1024).toFixed(2) + 'kB'} />
        </Stack>
      )}
    </CenteredColumn>
    <CenteredColumn width={'100%'}>
      <NamedValue
        name={'Triggers'}
        value={
          <Stack>
            {operationGroup.triggers.map((trigger: TriggerCreate, index: number) => (
              <TriggerCard key={index} trigger={trigger} />
            ))}
          </Stack>
        }
      />
      {operationGroup.operations.length > 0 && (
        <NamedValue
          name={'Operations'}
          value={
            <Stack>
              {operationGroup.operations.map((op, index) => (
                <OperationCard key={index} operation={op} />
              ))}
            </Stack>
          }
        />
      )}
    </CenteredColumn>
  </ReactiveRow>
);
